import {
    CustomSeriesPricePlotValues,
    ICustomSeriesPaneView,
    PaneRendererCustomData,
    Time,
    WhitespaceData
} from 'lightweight-charts'
import { defaultOptions, VertLineOptions } from './options'
import { VertLinesRenderer } from './renderer'
import { VerticalLineData } from './data'

export class VerticalLines<TData extends VerticalLineData>
    implements ICustomSeriesPaneView<Time, TData, VertLineOptions> {
    _renderer: VertLinesRenderer<TData>

    constructor() {
        this._renderer = new VertLinesRenderer()
    }

    priceValueBuilder(plotRow: TData): CustomSeriesPricePlotValues {
        return [plotRow.sy, plotRow.ey]
    }

    isWhitespace(data: TData | WhitespaceData): data is WhitespaceData {
        return false
    }

    renderer(): VertLinesRenderer<TData> {
        return this._renderer
    }

    update(
        data: PaneRendererCustomData<Time, TData>,
        options: VertLineOptions
    ): void {
        this._renderer.update(data, options)
    }

    defaultOptions() {
        return defaultOptions
    }
}
